import { Link } from 'react-router-dom'
import '../css/Header.css'
import '../css/hamburger.css'


export default function Header({viewOn, image, setOverlayState}) {
    return (
      <header className={viewOn ? "header trans" : "header"}>
        <div className={viewOn && image ? "title-box trans" : "title-box"}>
          <h1 className="header-name"><Link to="/" id="header-link" onClick={viewOn && (() => setOverlayState(false))}>Liz Alice John</Link></h1>
          <span className="header-job">Storyboarding and illustration</span>
        </div>
        <div className={viewOn ? 'mobile-nav-box on' : 'mobile-nav-box'} onClick={() => setOverlayState(!viewOn)}>
            <div className={viewOn ? 'ham ham-1 ham-on' : 'ham ham-1'}></div>
            <div className={viewOn ? 'ham ham-2 ham-on' : 'ham ham-2'}></div>
            <div className={viewOn ? 'ham ham-3 ham-on' : 'ham ham-3'}></div>
        </div>
        <nav className={!!image ? "navigation mobile-off wide-off" : viewOn ? "navigation mobile-on wide-on" : "navigation mobile-off wide-on"}>
          <ul className="nav-links">
              <li className='link-divider'></li>
              <li><Link to="/storyboarding" className="nav-link" onClick={viewOn && (() => setOverlayState(false))}>storyboards</Link></li>
              <li className='link-divider'></li>
              <li><Link to="/illustration" className="nav-link" onClick={viewOn && (() => setOverlayState(false))}>illustrations</Link></li>
              <li className='link-divider'></li>
              <li><Link to="/pixelart" className="nav-link" onClick={viewOn && (() => setOverlayState(false))}>pixel art</Link></li>
              <li className='link-divider'></li>
              <li><Link to="/contact" className="nav-link" onClick={viewOn && (() => setOverlayState(false))}>contact</Link></li>
          </ul>
        </nav>

      </header>
    )
}